import LogoIcon from '../../../../public/icons/logo.svg';
import BurgerIcon from '../../../../public/icons/menu.svg';
import CloseIcon from '../../../../public/icons/common/close.svg';
import s from './header.module.scss';
import Link from 'next/link';
import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import { useState, MouseEvent } from 'react';
import { useRouter } from 'next/router';
import LinksDropdown from '@/layout/header/components/links-dropdown/links-dropdown';

const MobileMenu = dynamic(() => import('@/layout/mobile-menu/mobile-menu'), {
  ssr: false,
});

const Button = dynamic(() =>
  import('@/ui/button/button').then((mod) => mod.Button)
);

const Header = ({ isCheckPage = false }) => {
  const t = useTranslations('Common');
  const { pathname } = useRouter();

  const [opened, setOpened] = useState(false);

  const isMain = pathname === '/';

  const toggleMenuDisplay = async () => {
    if (opened) {
      const { enableScroll } = await import('@/utils/helpers/disable-scroll');
      enableScroll();
    }

    setOpened((prev) => !prev);
  };

  const handleLink = (e: MouseEvent) => {
    if (isCheckPage) {
      e.preventDefault();

      window.location.href = '/';
    }
  };

  return (
    <header className={s.header}>
      <div className="container">
        {isMain && !isCheckPage ? (
          <LogoIcon />
        ) : (
          <Link href="/" onClick={handleLink} prefetch={false}>
            <LogoIcon />
          </Link>
        )}
        <div className={s.links}>
          <LinksDropdown />
        </div>
        <div className={s.actions}>
          <Link href="/imei-check" prefetch={false}>
            <Button className={s.headerBtn}>{t('ctaButton')}</Button>
          </Link>
          <Button
            variant="icon"
            className={s.burgerBtn}
            onClick={toggleMenuDisplay}
          >
            {opened ? <CloseIcon /> : <BurgerIcon />}
          </Button>
        </div>

        {opened && <MobileMenu toggleMenuDisplay={toggleMenuDisplay} />}
      </div>
    </header>
  );
};

export default Header;
